import React from 'react'
import SEO from './SEO';
import { generateOrganizationSchema, generateWebsiteSchema } from '../utils/structuredData';
import MailchimpSubscribeForm from './MailchimpSubscribeForm.jsx'

function Legal(props) {

  const featuredImage = 'https://discover.af-pictures.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';

  const organizationSchema = generateOrganizationSchema();
  const websiteSchema = generateWebsiteSchema();
  const combinedSchema = [organizationSchema, websiteSchema];

  return (
<>
  <SEO
    title="AF Pictures Club - The Club"
    description="Únete a nuestro club AF para recibir invitaciones a preestrenos y pases tests, recibir regalos promocionales, estar informado de nuestros próximos lanzamientos, participar en sorteos ¡y mucho más!"
    keywords="club AF Pictures, pases, regalos, entradas, invitaciones, peliculas, promociones"
    url="https://afpictures.com"
    image="https://afpictures.com/img/af-pictures-og.jpg"
    structuredData={combinedSchema}
  />
    <div style={{ backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover items-center h-[40vh]">
      <h1 style={{fontSize:'200%'}} className="text-center w-full pt-[20vh]  font-semibold text-white">ÚNETE AL CLUB AF</h1>
  </div>
    <div className={"flex flex-col justify-between  pl-0 md:pl-10" + props.transition}>


  <div className="pt-8 mb-16 lg:mb-0 lg:pt-32 lg:pr-5 text-gray-900">
    <p class="max-w-[640px] mx-auto text-white p-4 text-xl md:text-2xl">
      Únete a nuestro club para recibir invitaciones a preestrenos y pases tests, recibir regalos promocionales, estar informado de nuestros próximos lanzamientos, participar en sorteos <br/>¡y mucho más!
    </p>
    <MailchimpSubscribeForm/>

  </div>

</div>
</>
  )
}

export default Legal
